import {db} from "@/firebase"
import store from '@/store/index'

const projects_ref = db.collection("projects")

const createProjectLog = async (projectId,data) => {
    try {
        const get_data = await projects_ref
            .doc(projectId)
            .collection("logs")
            .add(data);
        return get_data.id;
    } catch (error) {
        throw new Error("createProjectLog Fail!" + error)
    }
}
const getProjectLog = async (projectId) => {
    let list = []
    try {
        const get_data = await projects_ref
            .doc(projectId)
            .collection("logs")
            .orderBy("createdAt","desc")
            .get();

            get_data.forEach((doc) => list.push(doc.data()));
        return list;
    } catch (error) {
        throw new Error("getProjectLog Fail!" + error)
    }
}

// ========== PROJECT NOTES FUNCTIONS ==========

/**
 * Obtém todas as observações de um projeto
 * @param {string} projectId - ID do projeto
 * @returns {Promise<Array>} Lista de observações
 */
const getProjectNotes = async (projectId) => {
    let list = []
    try {
        const get_data = await projects_ref
            .doc(projectId)
            .collection("notes")
            .orderBy("created_at","desc")
            .get();

        get_data.forEach((doc) => {
            list.push({
                id: doc.id,
                ...doc.data()
            });
        });
        return list;
    } catch (error) {
        throw new Error("getProjectNotes Fail!" + error);
    }
};

/**
 * Adiciona uma nova observação ao projeto
 * @param {string} projectId - ID do projeto
 * @param {string} content - Conteúdo da observação
 * @param {Object} user - Dados do usuário que está criando
 * @returns {Promise<string>} ID da observação criada
 */
const addProjectNote = async (projectId, content) => {
    try {
        console.log(projectId, content)
        const userId = store.state.currentUser?.uid
        const noteData = {
            content: content,
            created_at: new Date(),
            updated_at: new Date(),
            created_by: userId,
            updated_by: userId,
            deleted_at: null
        };
        
        const get_data = await projects_ref
            .doc(projectId)
            .collection("notes")
            .add(noteData);
        return get_data.id;
    } catch (error) {
        throw new Error("addProjectNote Fail!" + error);
    }
};

/**
 * Atualiza uma observação existente
 * @param {string} projectId - ID do projeto
 * @param {string} noteId - ID da observação
 * @param {string} content - Novo conteúdo da observação
 * @param {Object} user - Dados do usuário que está editando
 * @returns {Promise<void>}
 */
const updateProjectNote = async (projectId, noteId, content) => {
    try {
        const userId = store.state.currentUser?.uid
        const updateData = {
            content: content,
            updated_at: new Date(),
            updated_by: userId
        };
        
        await projects_ref
            .doc(projectId)
            .collection("notes")
            .doc(noteId)
            .update(updateData);
    } catch (error) {
        throw new Error("updateProjectNote Fail!" + error);
    }
};

/**
 * Remove uma observação (soft delete)
 * @param {string} projectId - ID do projeto
 * @param {string} noteId - ID da observação
 * @param {Object} user - Dados do usuário que está removendo
 * @returns {Promise<void>}
 */
const deleteProjectNote = async (projectId, noteId) => {
    try {
        const userId = store.state.currentUser?.uid
        const updateData = {
            deleted_at: new Date(),
            updated_at: new Date(),
            updated_by: userId
        };
        
        await projects_ref
            .doc(projectId)
            .collection("notes")
            .doc(noteId)
            .update(updateData);
    } catch (error) {
        throw new Error("deleteProjectNote Fail!" + error);
    }
};

/**
 * Remove permanentemente uma observação
 * @param {string} projectId - ID do projeto
 * @param {string} noteId - ID da observação
 * @returns {Promise<void>}
 */
const permanentlyDeleteProjectNote = async (projectId, noteId) => {
    try {
        await projects_ref
            .doc(projectId)
            .collection("notes")
            .doc(noteId)
            .delete();
    } catch (error) {
        throw new Error("permanentlyDeleteProjectNote Fail!" + error);
    }
};

/**
 * Obtém observações não deletadas de um projeto
 * @param {string} projectId - ID do projeto
 * @returns {Promise<Array>} Lista de observações ativas
 */
const getActiveProjectNotes = async (projectId) => {
    let list = []
    try {
        const get_data = await projects_ref
            .doc(projectId)
            .collection("notes")
            .where("deleted_at", "==", null)
            .orderBy("created_at","desc")
            .get();

        get_data.forEach((doc) => {
            list.push({
                id: doc.id,
                ...doc.data()
            });
        });
        return list;
    } catch (error) {
        throw new Error("getActiveProjectNotes Fail!" + error);
    }
};

/**
 * Restaura uma observação deletada
 * @param {string} projectId - ID do projeto
 * @param {string} noteId - ID da observação
 * @param {Object} user - Dados do usuário que está restaurando
 * @returns {Promise<void>}
 */
const restoreProjectNote = async (projectId, noteId) => {
    try {
        const userId = store.state.currentUser?.uid     
        const updateData = {
            deleted_at: null,
            updated_at: new Date(),
            updated_by: userId
        };
        
        await projects_ref
            .doc(projectId)
            .collection("notes")
            .doc(noteId)
            .update(updateData);
    } catch (error) {
        throw new Error("restoreProjectNote Fail!" + error);
    }
};


export default {
    createProjectLog,
    getProjectLog,
    // Project Notes functions
    getProjectNotes,
    addProjectNote,
    updateProjectNote,
    deleteProjectNote,
    permanentlyDeleteProjectNote,
    getActiveProjectNotes,
    restoreProjectNote,
};